import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import ContactImage from './contact.png';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Contact = () => {



  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false);
  const [message, setMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmit(true);

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      payload.append(key, value);
    });


    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}mycon/customer_support`, payload
      );
      if (response.data.response === 'success') {
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: ""
        });
        // setMessage(response.data.message);
        navigate('/thankyou');
      }
      if (response.data.response == 'invalid') {
        setMessage(response.data.message);
      }

    } catch (error) {
      console.error("There was an error While Form Submit!", error);
    } finally {
      setIsSubmit(false);
    }



  }


  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  }








  return (
    <div className="bginer" style={{ paddingTop: "100px" }}>
      <div className='container bginer'>
        <div className="contact-hero-section pt-5 pb-0 container ">
          <div className="text-center">
            <div className="heading mb-3 conust">
              <button class="contact-btn">Contact Us</button>
            </div>
            <h3 className="text-center bold-highl">
              WE ARE HERE TO <span className="highlight">ASSIST YOU</span>
            </h3>
            <p className="contact-subtitle">
              Most Trusted And Premium Matrimony Service In The World.
            </p>
          </div>
        </div>
        <div className='container pb-5'>
          <Row className="mb-5 mt-4">
            <div class="col-md-4 boxshadwe">
              <div className="contact-box p-4 shadowja">
                <h3 className="contact-heading mb-3 heading">Contact Us</h3>
                <p className="contact-text">For any inquiries, assistance, or feedback related to your experience on:</p>
                <ul className="list-unstyled contact-list mt-4">
                  <li>
                    <FaPhoneAlt className="me-2" /> +91 8088010188
                  </li>
                  <li>
                    <FaEnvelope className="me-2" /> hindusanjog@gmail.com
                  </li>
                  {/* <li>
                    <FaMapMarkerAlt className="me-2" /> 28800 Orchard Lake Road, Suite 180 Farmington Hills, U.S.A.
                  </li> */}
                </ul>
              </div>
            </div>
            <div class="col-md-8 xysla">
              <div className="info-box ps-md-5 ">
                <div className='top-space'>
                  <h3 className="info-title">Need Any <span class="heading">Assistance?</span></h3>
                </div>

                <p>
                  Whether you’re seeking support with your profile, need help navigating the platform, or have questions
                  regarding our services, our dedicated team is here to help.
                </p>
                <p>
                  We aim to provide you with the best matrimonial experience and will respond promptly to ensure all your
                  needs are met. Your journey towards finding the perfect match is important to us.
                </p>
              </div>
            </div>
          </Row>
          <Row className="align-items-center enquiry-form-box g-4 shadowja ">
            <div class="col-md-6 marginimge">
              <img src={ContactImage} alt="Contact Representation" className="jaatimg rounded shadow-sm" />
            </div>
            <Col md={6} className='mt-0'>
              <div className="p-2">
                <h5 className="mb-0 lets text-center">Let's Talk</h5>
                <h6 className="mb-0 sendre text-center">Send Your Enquiry <span>Now</span></h6>
                <Form method='post' onSubmit={handleSubmit}>
                  <Form.Group controlId="name" className="mb-3">
                    <Form.Label>Name</Form.Label>
                    <input class="holdre" onChange={handleChange} name='name' type="text" placeholder="Enter your name" required />
                  </Form.Group>
                  <Form.Group controlId="email" className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <input class="holdre" onChange={handleChange} type="email" name='email' placeholder="Enter your email" required />
                  </Form.Group>
                  <Form.Group controlId="phone" className="mb-3">
                    <Form.Label>Phone</Form.Label>
                    <input class="holdre" onChange={handleChange} type="text" name="phone" placeholder="Enter your phone" required />
                  </Form.Group>
                  <Form.Group controlId="message" className="mb-3">
                    <Form.Label>Message</Form.Label>
                    <Form.Control onChange={handleChange} placeholder='Enter Message' name="message" class="msekal" as="textarea" rows={3} />
                  </Form.Group>
                  {!isSubmit &&
                    <Button disabled={isSubmit} className="enquiry-btn w-100 my-3" type="submit">Send Enquiry</Button>
                  }
                  {isSubmit &&
                    <Button disabled={isSubmit} className="enquiry-btn w-100 my-3" type="button">Sending...</Button>
                  }

                  {message &&
                    <div class="border alert alert-danger"><strong>{message}</strong></div>
                  }



                </Form>

              </div>
            </Col>
          </Row>
        </div>

      </div>
      <style>
        {
          ` 
      . @media (max-width: 767px) {
        .msekal{ width:100%;
        }
        
      }



      .holdre {
        display: block;
        width: 100%;
        padding: 9.5px 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: var(--bs-body-color);
        background-color: var(--bs-body-bg);
        background-clip: padding-box;
        border: var(--bs-border-width) solid var(--bs-border-color);
        appearance: none;
        border-radius: 15px;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      }


      .boxshadwe {
        padding: 0 0 0 0 !important;
      }


      @media (max-width: 767px) {
        .marginimge {
          display: none;
        }
      }

      .marginimge {
        margin-top: 0 !important;
            padding-left: 0px;
      }




      .jaatimg {
        height: 676px;
        width: 640px;
      }

      .xysla {
        padding-right: 66px;
      }

      .top-space {
        margin-top: 20px;
      }

      .bginer {
        background: white;

        .shadowja {
          box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.075) !important
        }

      }


      .mb-3{
      margin-bottom:5px !important;}

      .form-label {
        margin-bottom: 0px;
        color: black;
      }

      .contact-btn {
        background-color: #ffecec;
        /* light pink background */
        color: #e91e63;
        /* black text */
        border: none;
        /* no border */
        padding: 10px 20px;
        /* spacing inside button */
        border-radius: 8px;
        /* rounded corners */
        font-weight: 500;
        /* medium bold text */
        font-size: 16px;
        /* text size */
        cursor: pointer;
        /* cursor changes on hover */
      }

      .contact-hero-section {
        background-color: #fff;
        padding-top: 60px;
        padding-bottom: 60px;
      }

      .conust {
        font-size: 22px;
        font-weight: bold;
      }

      .bold-highl {
        font-weight: 500;
      }

      .contact-label {
        display: inline-block;
        background-color: #fce4ec;
        /* Light pink */
        color: #c2185b;
        /* Deep pink */
        font-size: 14px;
        padding: 5px 12px;
        border-radius: 5px;
        font-weight: 500;
      }



      .contact-title {
        font-size: 28px;
        font-weight: bold;
        color: #000;
      }

      .contact-title .highlight {
        color: #e91e63;
        /* Highlighted pink */

      }

      .highlight {
        font-weight: 800;
      }

      .contact-subtitle {
        font-size: 16px;
        color: #444;
        margin-top: 10px;
      }

      .contact-section {
        padding: 60px 0;
        background-color: #fff;
      }

      .contact-box {
        border-radius: 10px;
        background: white;

      }

      .sendre {
        font-size: 20px;
        font-weight: bold;
      }

      .contact-heading {
        color: #E53D5C;
        font-weight: 800;
      }

      .contact-text {
        color: #333;
        font-size: 15px;
      }

      .contact-list li {
        margin-bottom: 10px;
        font-size: 15px;
        color: #444;
        display: flex;
        align-items: center;
      }



      .info-box .info-title span {
        color: #E53D5C;
        font-weight: 800;
      }

      .info-box p {
        color: #555;
        font-size: 15px;
      }

      .enquiry-form-box {
        background: white;
        border-radius: 10px;
      }

      .enquiry-form-box h6 span {
        color: #E53D5C;
        font-weight: 800;
      }

      .lets {
        font-size: 27px;
        font-weight: bold;
      }

      . .enquiry-btn {
        background-color: #E53D5C;
        border: none;
        font-weight: 500;
        transition: background 0.3s ease;
      }

      .enquiry-btn:hover {
        background-color: #d63350;
      }

      .b `
        }
      </style>
    </div>
  );
};

export default Contact;